import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import Button from '../components/Button';
import { Modal, ModalName, ModalPart } from '../components/Modal';
import { DELETE_TOPIC } from '../utilities/mutations';
import { deleteTopicCache } from '../utilities/cache';
import { useSpaceContext } from '../contexts/space';

const DeleteTopicModal = ({ topicId, spaceSlug, onClose, dontRedirect }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { spaceVars } = useSpaceContext();
  const [deleteTopic] = useMutation(DELETE_TOPIC, {
    variables: { id: topicId },
    update: (cache, { data: { deleteTopic } }) =>
      deleteTopicCache(spaceVars, spaceSlug, cache, deleteTopic),
  });

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  const search = new URLSearchParams();

  if (location.state?.filters?.author) {
    search.append('author', location.state?.filters?.author);
  }

  if (location.state?.filters?.state) {
    search.append('state', location.state?.filters?.state);
  }

  if (location.state?.filters?.assignee) {
    search.append('assignee', location.state?.filters?.assignee);
  }

  if (location.state?.filters?.tag) {
    search.append('assignee', location.state?.filters?.tag);
  }

  return (
    <Modal onClose={() => close()} isDanger>
      <ModalName>Delete topic</ModalName>
      <ModalPart>Are you sure you want to delete this topic?</ModalPart>
      <ModalPart>
        <Button onClick={() => close()} isExtended>
          Cancel
        </Button>
        <Button
          onClick={() => {
            deleteTopic();
            if (onClose) {
              onClose();
            }
            !dontRedirect &&
              navigate({ pathname: `/s/${spaceSlug}`, search: `?${search}` });
          }}
          isDanger
          isExtended
        >
          Delete
        </Button>
      </ModalPart>
    </Modal>
  );
};

export default DeleteTopicModal;
